// @flow

import React from 'react';
import {Field, reduxForm} from 'redux-form';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';

export type Props = {
  roomTypes: any[],
  workerTypes: any[],
};

const OrderCommentForm = ({
  roomTypes,
  workerTypes,
}: Props) => (
  <div className="OrderCommentForm">
    <Field
      name="workerTypeId"
      label="Yrkeskategori"
      normalize={value => value ? value.id : null}
      clearable={true}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={workerTypes} />
    <Field
      name="roomTypeId"
      label="Rumstyp"
      normalize={value => value ? value.id : null}
      clearable={true}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={roomTypes} />
    <Field
      name="note"
      label="Kommentar"
      component={TextAreaFormInput} />
  </div>
);

export default reduxForm({
  form: 'orderComment',
  enableReinitialize: true,
})(OrderCommentForm);



// WEBPACK FOOTER //
// ./src/components/OrderCommentForm/OrderCommentForm.js